module.exports = __webpack_public_path__ + "ecf7784e703bce5c81afd21577c44cf8.png";